import datamethods from './datamethods.js'
import {mapFields} from 'vuex-map-fields'
export default{
    mixins:[datamethods],
    computed:{
        ...mapFields([
            
            'loggedInUser',
            'securityAppName',
            'applicationMode',

        ]),
        
    },
    data(){
        return{
            
        }
    },
    methods:{
        


        
    }

}